import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { TQC2080_R01Dto } from "./Dto_TQC2080_R01";
import { getData, postData, deleteData } from "src/utils/axios/serverHelper";
import { TQC2080_R01Filter } from "./Store_TQC2080_R01";

const baseUrl = `${config.apiUrl}/TQC2080_R01`;

// 연도별 날짜 목록 조회
export const getTQC2080_R01DateList = async (year: string) => {
	return await getData<ResponseDto<string[]>>(`${baseUrl}/dates`, {
		params: { year },
	});
};

// 날짜별 그리드 데이터 조회
export const getTQC2080_R01Search = async (params: Partial<TQC2080_R01Filter>) => {
	return await getData<ResponseDto<TQC2080_R01Dto[]>>(`${baseUrl}/search`, {
		params,
	});
};

// 차트용 연간 데이터 조회
export const getTQC2080_R01ChartData = async (year: string) => {
	return await getData<ResponseDto<TQC2080_R01Dto[]>>(`${baseUrl}/chart`, {
		params: { year },
	});
};

// 저장 (upsert)
export const saveTQC2080_R01 = async (data: {
	analysisDt: string;
	dtlList: TQC2080_R01Dto[];
}) => {
	return await postData<typeof data, ResponseDto<void>>(baseUrl, data);
};

// 삭제
export const deleteTQC2080_R01 = async (analysisDt: string) => {
	return await deleteData<ResponseDto<void>>(`${baseUrl}/${analysisDt}`);
};

// 엑셀 다운로드
export const downloadExcel_TQC2080_R01 = async (params: Partial<TQC2080_R01Filter>) => {
	return await getData<ResponseDto<string>>(`${baseUrl}/excel`, { params });
};

// PDF 출력 (일지·날짜별)
export const downloadPdf_TQC2080_R01 = async (analysisDt: string) => {
	return await getData<Blob>(`${baseUrl}/pdf/${analysisDt}`, {
		responseType: "blob",
		headers: { Accept: "application/pdf" },
	});
};

// 추이 차트 PDF (연도별)
export const downloadChartPdf_TQC2080_R01 = async (year: string) => {
	return await getData<Blob>(`${baseUrl}/pdf/chart/${year}`, {
		responseType: "blob",
		headers: { Accept: "application/pdf" },
	});
};
